import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"
import ChangePassword from "pages/Authentication/ChangePassword"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import PublicCustomerComplaints from "pages/ComplaintsLandingPage"
import Users from "pages/SystemUsers/Users"
import Staff from "pages/Maintenance/Staff"
import AssetRegister from "pages/Assets/AssetRegister"
import AssetMap from "pages/Assets/AssetMap"
import Assets from "pages/Assets/Assets"
import AddAsset from "pages/Assets/AddAssets"
import WQuality from "../pages/WQ/WQ"
import Parameters from "../pages/WQ/Parameters"
import SamplingPoints from "pages/WQ/SamplingPoints"
import WQData from "pages/WQ/WQData"
import WQDataDetails from "pages/WQ/WQDataDetails"
import AddWQData from "pages/WQ/AddWQData"
import WaterSampling from "pages/WQ/WaterSampling"
import SamplingPointsMap from "pages/WQ/SamplingPointsMap"
import WaterSamplingReport from "pages/WQ/SamplingReport"
import Dashboard from "../pages/Dashboard/index"
import PPMCalendar from "pages/Maintenance/PPMCalendar"
import ComplaintsCategories from "pages/Customers/ComplaintsCategories"
import CustomerComplaints from "pages/Customers/CustomerComplaints"
import AddComplaint from "pages/Customers/AddComplaint"
import ComplaintDetails from "pages/Customers/ComplaintDetails"
import ComplaintMessages from "pages/Customers/ComplaintMessages"
import BillPayments from "pages/Payments/BillPayments"
import WorkRequests from "pages/Maintenance/WorkRequests"
import WorkOrders from "pages/Maintenance/WorkOrders"
import CreateWorkOrder from "pages/Maintenance/CreateWorkOrder"
import WorkOrderDetails from "pages/Maintenance/WorkOrderDetails"
import CallCenterReport from "pages/Customers/CallCenterReport"
import SMSReminders from "pages/Customers/SMSReminders"
import PPMLibrary from "pages/Maintenance/PPMLibrary"
import WaterProduction from "pages/Production/WaterProduction"
import AddWaterProduction from "pages/Production/AddWaterProduction"
import WaterProductionDetails from "pages/Production/WaterProductionDetails"
import Seetup from "pages/SystemUsers/Setup"
import Notifications from "pages/Notifications/Notifications";
import GIS from "pages/GIS/GIS"
import CallCenter from "pages/Customers/CallCenter"
import HRDashboard from "pages/HumanResourcesDashboard"
import Employees from "pages/HumanResources/Employees"
import HumanResourceSettings from "pages/HumanResources/HumanResourceSettings"
import EmployeeDetails from "pages/HumanResources/EmployeeDetails"
import Organogram from "pages/HumanResources/Organogram"
import LeavePlanning from "pages/HumanResources/LeavePlanning"
import LeaveManagement from "pages/HumanResources/LeaveManagement"
import PersonalData from "pages/HumanResources/PersonalData"
import PersonalLeavePlans from "pages/HumanResources/PersonalLeavePlans"
import LeavePlanDetails from "pages/HumanResources/LeavePlanDetails"
import PersonalLeave from "pages/HumanResources/PersonalLeave"
import LeaveDetails from "pages/HumanResources/LeaveDetails"
import PerformanceAgreements from "pages/HumanResources/PerformanceAgreements"
import PerformanceAgreementDetails from './../pages/HumanResources/PerformanceAgreementDetails';
import Appraisals from "pages/HumanResources/Appraisals"
import AppraisalDetails from "pages/HumanResources/AppraisalDetails"
import Suppliers from "pages/Inventory/Suppliers"
import Inventory from "pages/Inventory/Inventory"
import InventorySetup from "pages/Inventory/InventorySetup"
import StockMovement from "pages/Inventory/StockMovement"
import Payroll from "pages/HumanResources/Payroll"
import PayrollDetails from "pages/HumanResources/PayrollDetails"
import PayAdjustments from "pages/HumanResources/PayAdjustments"
import PayAdjustmentsReport from "pages/HumanResources/PayAdjustmentsReports"
import Attendance from "pages/HumanResources/Attendance"
import DisciplinaryAndGrievances from "pages/HumanResources/DisciplinaryAndGrievances"
import PersonalDisciplinaryAndGrievances from "pages/HumanResources/PersonalDisciplinaryAndGrievances"


const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/system-users", component: Users },
  { path: "/Assets", component: Assets },
  { path: "/Add-Asset", component: AddAsset },
  { path: "/Asset-Register", component: AssetRegister },
  { path: "/Asset-Map", component: AssetMap },
  { path: "/PPM-Calendar", component: PPMCalendar },
  { path: "/Maintenance-Staff", component: Staff },
  { path: "/Work-Requests", component: WorkRequests },
  { path: "/Work-Order-Management", component: WorkOrders },
  { path: "/Create-WorkOrder/:id", component: CreateWorkOrder },
  { path: "/WorkOrder-Details/:id", component: WorkOrderDetails },
  { path: "/PPM-Library", component: PPMLibrary },

  { path: "/WQ", component: WQuality },
  { path: "/Parameters", component: Parameters },
  { path: "/Sampling-Points", component: SamplingPoints },
  { path: "/Water-Quality-Data", component: WQData },
  { path: "/Add-Quality-Data", component: AddWQData },
  { path: "/Sampling-Points-Map", component: SamplingPointsMap },
  { path: "/Water-Sampling", component: WaterSampling },
  { path: "/Water-Quality-Details/:id", component: WQDataDetails },
  { path: "/Sampling-Report", component: WaterSamplingReport },

  { path: "/Complaints-Categories", component: ComplaintsCategories },
  { path: "/Customer-Complaints", component: CustomerComplaints },
  { path: "/Register-Complaint", component: AddComplaint },
  { path: "/Customer-Complaint-Details/:id", component: ComplaintDetails },
  { path: "/Complaint-Messages", component: ComplaintMessages },
  { path: "/Call-Center-Reports", component: CallCenterReport },
  { path: "/Call-Center", component: CallCenter },
  { path: "/sms-bill-reminders", component: SMSReminders },
  { path: "/Bill-Payments", component: BillPayments},
  { path: "/GIS", component: GIS},

  { path: "/water-production", component: WaterProduction },
  { path: "/add-water-production", component: AddWaterProduction },
  { path: "/water-production-details/:id", component: WaterProductionDetails },

  { path: "/human-resources", component: HRDashboard },
  { path: "/employees", component: Employees },
  { path: "/human-resource-settings", component: HumanResourceSettings },
  { path: "/employee-details/:id", component: EmployeeDetails },
  { path: "/personal-details", component: PersonalData },
  { path: "/personal-leave-plan", component: PersonalLeavePlans },
  { path: "/personal-leave", component: PersonalLeave },
  { path: "/leave-details/:id", component: LeaveDetails },
  { path: "/leave-plan-details/:id", component: LeavePlanDetails },
  { path: "/organogram", component: Organogram },
  { path: "/leave-planning", component: LeavePlanning },
  { path: "/leave-management", component: LeaveManagement },
  { path: "/performance-agreements", component: PerformanceAgreements },
  { path: "/performance-agreement-details/:id", component: PerformanceAgreementDetails },
  { path: "/appraisals", component: Appraisals },
  { path: "/appraisal-details/:id", component: AppraisalDetails },
  { path: "/payroll", component: Payroll },
  { path: "/payroll-details/:id", component: PayrollDetails },
  { path: "/pay-adjustments", component: PayAdjustments },
  { path: "/pay-adjustments-reports", component: PayAdjustmentsReport },
  { path: "/attendance", component: Attendance },
  { path: "/disciplinary-and-grievancies", component: DisciplinaryAndGrievances },
  { path: "/personal-disciplinary-and-grievancies", component: PersonalDisciplinaryAndGrievances },

  { path: "/Suppliers-and-Contractors", component: Suppliers },
  { path: "/Inventory", component: Inventory },
  { path: "/Stock-Movement", component: StockMovement },
  { path: "/Spares-and-Materials", component: StockMovement },
  { path: "/Inventory-Setup", component: InventorySetup },
  
  // profile
  { path: "/profile", component: UserProfile },
  { path: "/other-setup", component: Seetup },

  { path: "/Notifications", component: Notifications },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/change-password", component: ChangePassword },
  { path: "/register", component: Register },
  { path: "/public-customer-complaints", component: PublicCustomerComplaints },
]

export { publicRoutes, authProtectedRoutes }
